import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon(React.createElement("path", {
  d: "M8 5v14l11-7L8 5z"
}), 'PlayArrowSharp');